export  const DATE_FORMAT={
    format:(date:any ,localLanguage:string|undefined,pattern:string)=>{

        let  dateFormatted = null;
        switch (pattern) {
            case 'M-Y':
                dateFormatted = new Intl.DateTimeFormat(localLanguage, {
                    month: "long",
                    year: "numeric"
                  }).format(date);

                break;
        
            default:
                dateFormatted =  date;
                break;
        }

        return dateFormatted;

    }
}

